<script>
  import { createEventDispatcher } from 'svelte'
  const dispatch = createEventDispatcher()

  import Modal from './Modal.svelte'
  import { getApiUrl, fetchWithSession } from './util'

  export let data

  let awaitingRefresh = false
  function onDataChange(d) { awaitingRefresh = false }
  $: { onDataChange(data) }

  // Variables related to the modal for error type and text.

  let errorTypeTextModal
  let modalMode

  let errortext
  let errortype

  const errortypes = [
    {val: 'logic'  , lbl: 'Logic'},
    {val: 'missing', lbl: 'Missing'},
    {val: 'range'  , lbl: 'Range'},
  ]

  // Variables related to the modal to select querycontrol value.

  let queryControlModal
  let querycontrol = data.querycontrol

  let querycontrolvalues = [
    {val: 'autohold'  , lbl: 'Auto-hold on query'},
    {val: 'manualhold', lbl: 'Manual hold on query'},
    {val: 'permanent' , lbl: 'Mark error as permanent (no query)'},
    {val: 'normal'    , lbl: 'Normal query mode'},
  ]

  // End of modal variables.

  function getFieldApiUrl(oppath) {
    const apipath = `forms/${data.formid}/` +
                    `fields/${data.fieldname}/${oppath}`
    return getApiUrl(apipath)
  }

  function showErrorTypeTextModal(mode) {
    modalMode = mode
    errortype = data.errortype || 'logic'
    errortext = data.errortext
    errorTypeTextModal.show()
  }

  function dispatchStaleDataEvent() {
    awaitingRefresh = true
    dispatch('stalefielddata') //,
            // { onRefreshApiReturned: () => {
            //     awaitingRefresh = false
            //   }
            // })
  }


  // Duplicated in FormActions
  async function fetchWrapper(url, options) {
    options['cache'] = 'no-store'
    let res
    try {
      res = await fetchWithSession(url, options)
      if (!res.ok) {
        console.log(res)
        res?.text().then(t => console.log(t))
        alert('ERROR: API call status ' + res.status)
      }
    } catch(err) {
      console.log(err)
      alert('ERROR attempting API call.  See browser console log.')
    }
    return res
  }


  async function executeErrorModalAction() {
    let bodydata, apiurl, method

    if (modalMode === 'forceerror') {
      bodydata = { errortext, errortype }
      apiurl = getFieldApiUrl('forcederror')
      method = 'POST'
    } else if (modalMode === 'errortext') {
      bodydata = { errortext }
      apiurl = getFieldApiUrl('error')
      method = 'PATCH'
    }

    console.log(bodydata)
    const res = await fetchWrapper(apiurl,
      { method,
        headers: { 'Content-Type': 'application/json'},
        body: JSON.stringify(bodydata)
      })
    if (res?.ok) {
      dispatchStaleDataEvent()
      errorTypeTextModal.hide()
    }
    modalMode = null
  }

  async function unforceErrorConfirm() {
    if (window.confirm('You are about to unforce the error')) {
      try {
        awaitingRefresh = true
        const apiurl = getFieldApiUrl('forcederror')
        await fetchWrapper(apiurl, { method: 'DELETE' })
      } finally {
        dispatchStaleDataEvent()
      }
    }
  }

  async function acceptErrorAction() {
    try {
      awaitingRefresh = true
      const apiurl = getFieldApiUrl('forcedacceptance')
      await fetchWrapper(apiurl, { method: 'POST' })
    } finally {
      dispatchStaleDataEvent()
    }
  }

  async function unacceptErrorAction() {
    try {
      awaitingRefresh = true
      const apiurl = getFieldApiUrl('forcedacceptance')
      await fetchWrapper(apiurl, { method: 'DELETE' })
    } finally {
      dispatchStaleDataEvent()
    }
  }

  function showQueryControlModal() {
    querycontrol = data.querycontrol
    queryControlModal.show()
  }

  async function executeQueryControlModalAction() {
    const postdata = { querycontrol }
    console.log(postdata)
    const apiurl = getFieldApiUrl('error')
    const res = await fetchWrapper(apiurl,
      { method: 'PATCH',
        headers: { 'Content-Type': 'application/json'},
        body: JSON.stringify(postdata)
      })
    if (res?.ok) {
      dispatchStaleDataEvent()
      queryControlModal.hide()
    }
  }

  $: isCurrentUnforcedErrorOnlyF = data.errorstatus === 'current' &&
                                   data.fstatus !== 'forcederror' &&
                                   ( data.formfieldvalueid === null ||
                                     data.kstatus === 'accepted')

  $: isForcedAccept = (data.fstatus === 'forcedaccept' ||
                       data.errorstatus === 'accepted')

  $: isErrorInclAccepted = (['current', 'accepted'].includes(
                                             data.errorstatus) ||
                            data.fstatus === 'forcedaccept')
</script>

<fieldset class=actionbuttons disabled={awaitingRefresh}>
  <legend>Actions on selected field value</legend>
  <button on:click={() => showErrorTypeTextModal('forceerror')}
          class:show={!isErrorInclAccepted}
    >Force error</button>
  <button on:click={unforceErrorConfirm}
          class:show={data.fstatus==='forcederror'}
    >Unforce error</button>
  <button on:click={acceptErrorAction}
          class:show={isCurrentUnforcedErrorOnlyF}
    >Accept error value</button>
  <button on:click={unacceptErrorAction}
          class:show={isForcedAccept}
    >Revert forced acceptance</button>
  <button on:click={showQueryControlModal}
          class:show={data.errorstatus==='current'}
    >Change query control setting</button>
  <button on:click={() => showErrorTypeTextModal('errortext')}
          class:show={isErrorInclAccepted}
    >Change error text</button>
</fieldset>

<Modal bind:this={errorTypeTextModal}>
  {#if modalMode === 'forceerror'}
    <h3 class=modaltitle >Force error on field {data.fieldname}</h3>
  {:else}
    <h3>Edit error text for field {data.fieldname}</h3>
  {/if}
  <label class=errortext>
    Error text: <input type=text bind:value={errortext} />
  </label>
  {#if modalMode === 'forceerror'}
    <fieldset class=errortype>
      Error type:
      {#each errortypes as errtyp}
        <label>
          <input type=radio bind:group={errortype} value={errtyp.val}>
          {errtyp.lbl}
        </label>
      {/each}
    </fieldset>
  {/if}
  <div>
    <button on:click={errorTypeTextModal.hide}>Cancel</button>
    <button on:click={executeErrorModalAction}>Save</button>
  </div>
</Modal>

<Modal bind:this={queryControlModal}>
  <h3 class=modaltitle >Set query control on field {data.fieldname} in form
      {data.shortformname}</h3>
  <fieldset class=querycontrol>
    {#each querycontrolvalues as qcval}
      <label>
        <input type=radio bind:group={querycontrol} value={qcval.val}
               disabled={qcval.val==='autohold' && data.querycontrol!=='autohold'}>
        {qcval.lbl}
      </label>
    {/each}
  </fieldset>
  <div>
    <button on:click={queryControlModal.hide}>Cancel</button>
    <button on:click={executeQueryControlModalAction}
            disabled={querycontrol===data.querycontrol}>Save</button>
  </div>
</Modal>

<style>
  .actionbuttons {
    margin-top: 1em;
    display: inline-block;
  }
  .actionbuttons button {
    display: none;
  }
  .actionbuttons button.show {
    display: initial;
  }
  .modaltitle {
    margin: .5em 0;
  }
  label.errortext {
    display: block;
    margin-bottom: 1em;
  }
  .errortext input {
    width: 30em;
  }
  fieldset.errortype {
    margin: 0 0 1em 0;
    padding: 0;
    border: none;
  }
  fieldset.errortype label {
    padding-left: 1em;
  }
  fieldset.querycontrol {
    border: none;
    padding-top: 0;
  }
  .querycontrol label {
    display: block;
    padding: .15em;
  }
</style>
